module.exports = __webpack_public_path__ + "static/media/refrigerator.937dd3e6.svg";